import React, { forwardRef } from "react";
import { bool, func, node, string } from "prop-types";

import * as S from "./styled";

const Button = forwardRef(
  ({ children, isNew, onMouseEnter, onMouseLeave, title, ...props }, ref) => (
    <S.ListItem
      ref={ref}
      isNew={isNew}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <S.Link
        as={props.href ? "a" : "button"}
        type={!props.href ? "button" : undefined}
        {...props}
      >
        {title}
      </S.Link>
      {children}
    </S.ListItem>
  )
);

Button.propTypes = {
  isNew: bool,
  href: string,
  children: node,
  title: string,
  onMouseEnter: func,
  onMouseLeave: func
};

Button.defaultProps = {
  isNew: false,
  children: "",
  onMouseEnter: () => ({}),
  onMouseLeave: () => ({}),
  href: undefined,
  title: ""
};

export default Button;
